import { useEffect, useMemo, useState } from 'react';
import WorkSpaceService from 'services/master/workspace';

const service = new WorkSpaceService();

const PACKAGE_LABELS = {
  mien_phi: 'Miễn phí',
  mini: 'Mini',
  pro: 'Pro',
  vip: 'VIP',
};

const useComponent = () => {
  const [workspaces, setWorkspaces] = useState([]);

  const load = async () => {
    const list = await service.list();
    setWorkspaces(Array.isArray(list) ? list : []);
  };

  useEffect(() => {
    load();
  }, []);

  const summary = useMemo(() => {
    const byPackage = {
      mien_phi: 0,
      mini: 0,
      pro: 0,
      vip: 0,
    };

    const now = new Date();
    const sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);

    const newShops = [];

    (workspaces || []).forEach((item) => {
      const tier = item?.subscription?.tier || 'mien_phi';
      if (Object.prototype.hasOwnProperty.call(byPackage, tier)) {
        byPackage[tier] += 1;
      } else {
        byPackage.mien_phi += 1;
      }

      const createdOn = item?.create_on ? new Date(item.create_on) : null;
      if (createdOn && createdOn >= sevenDaysAgo && createdOn <= now) {
        newShops.push(item);
      }
    });

    newShops.sort((a, b) => new Date(b?.create_on || 0) - new Date(a?.create_on || 0));

    // Storage aggregates
    let totalStorageUsed = 0;
    let totalStorageLimit = 0;
    const topStorage = [];
    (workspaces || []).forEach((item) => {
      const info = item?.storage_info || {};
      totalStorageUsed += Number(info.used_bytes || 0);
      totalStorageLimit += Number(info.limit_bytes || 0);
      if (info.used_bytes > 0) {
        topStorage.push(item);
      }
    });
    topStorage.sort((a, b) => (b?.storage_info?.used_bytes || 0) - (a?.storage_info?.used_bytes || 0));
    const topStorageShops = topStorage.slice(0, 5);

    return {
      totalShops: workspaces.length,
      byPackage,
      newShops,
      totalStorageUsed,
      totalStorageLimit,
      topStorageShops,
    };
  }, [workspaces]);

  return {
    summary,
    packageLabels: PACKAGE_LABELS,
  };
};

export default useComponent;
